<!--
* @FileDescription: Cookie相关工具
* @Author: Rocky
* @Date: 2020-08-28
* @LastEditors: Rocky
* @LastEditTime: 2020-08-28
-->
<script>
/**
 * 获取 cookie
 * @param {string} cName cookie名称
 */
function getCookie (cName) {
  var name = cName + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

/**
 * 设置 cookie
 * @param {string} cName cookie名称
 * @param {mix} cVal cookie值
 * @param {int} exp 过期时间（天）
 */
function setCookie (cName, cVal, exp) {
  var d = new Date()
  d.setTime(d.getTime() + (exp * 24 * 60 * 60 * 1000))
  var expires = 'expires=' + d.toGMTString()
  document.cookie = cName + '=' + cVal + ';' + expires + ';path=/'
  return true
}

/**
 * 清除 cookie
 * @param {string} cName cookie名称
 */
function clearCookie (cName) {
  this.setCookie(cName, '', -1)
  return true
}

export default {
  getCookie, setCookie, clearCookie
}
</script>



// WEBPACK FOOTER //
// src/components/toolkits/cookie.vue